/** ChipsField — multi-select chip row driven by a picks list. */
import { MultiSelectChips } from "../_shared";

export default function ChipsField({ field, value, set, picks }) {
  const options = (picks && picks[field.optionsFromPicks]) || [];
  return (
    <MultiSelectChips
      label={field.label}
      testid={field.testid}
      options={options}
      value={value || []}
      onChange={(arr) => set(field.key, arr)}
    />
  );
}
